import { render, staticRenderFns } from "./Navbar.vue?vue&type=template&id=4ba8760e&scoped=true&lang=pug&"
var script = {}
import style0 from "./Navbar.vue?vue&type=style&index=0&id=4ba8760e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4ba8760e",
  null
  
)

export default component.exports